// src/components/BrandLogo.js
// Logo du site : sceau CCMA en arabe pour la version arabe,
// sceau CCMA en français pour les versions française et anglaise.
//   <BrandLogo lang={lang} />                  256 px : en-tête, pied de page
//   <BrandLogo lang={lang} large decorative /> 800 px : visuel de la page d'accueil
import React from "react";
import logoArPng from "../assets/logo-ccma-ar.png";
import logoArWebp from "../assets/logo-ccma-ar.webp";
import logoFrPng from "../assets/logo-ccma-fr.png";
import logoFrWebp from "../assets/logo-ccma-fr.webp";
import logoArLgPng from "../assets/logo-ccma-ar-lg.png";
import logoArLgWebp from "../assets/logo-ccma-ar-lg.webp";
import logoFrLgPng from "../assets/logo-ccma-fr-lg.png";
import logoFrLgWebp from "../assets/logo-ccma-fr-lg.webp";

const FILES = {
  ar: { small: [logoArWebp, logoArPng], large: [logoArLgWebp, logoArLgPng] },
  fr: { small: [logoFrWebp, logoFrPng], large: [logoFrLgWebp, logoFrLgPng] },
};

const ALT = {
  ar: "مركز المصالحة والوساطة والتحكيم - الغرفة الجزائرية للتجارة والصناعة",
  fr: "Centre de la conciliation, de la médiation et d'arbitrage - Chambre algérienne de commerce et d'industrie",
  en: "Conciliation, Mediation and Arbitration Centre - Algerian Chamber of Commerce and Industry",
};

export default function BrandLogo({ lang = "fr", className = "", large = false, decorative = false }) {
  const code = String(lang || "fr").slice(0, 2).toLowerCase();
  const [webp, png] = FILES[code === "ar" ? "ar" : "fr"][large ? "large" : "small"];
  const size = large ? 800 : 256;

  return (
    <picture className={className}>
      <source srcSet={webp} type="image/webp" />
      <img src={png} alt={decorative ? "" : ALT[code] || ALT.fr} width={size} height={size} decoding="async" />
    </picture>
  );
}
